import { BUCKET_MEDIA_HOST } from './constants';

export function getOriginalSizeImage(url: string): string {
  if (url && url.includes(BUCKET_MEDIA_HOST)) {
    return url.split('=')[0] + '=s0-rw';
  }
  return url;
}
